export default __webpack_public_path__ + "static/media/about-carousel-4-water.6d9e7504.jpg";